export enum MapObjectType {
  Path = 'path',
  Aoi = 'aoi',
  Poi = 'poi',
}